import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const LEGACY_CATEGORY = 'Data Map';

const SPATIAL_LAYER_EVENT_NAMES = {
  DISCLAIMER_CLICK: 'map_spatial_layer_disclaimer_click',
  CLICK_FLOOR_ARROW: 'map_spatial_layer_click_floor_arrow',
  CLICK_LINK_OUT: 'map_spatial_layer_click_link_out',
  CLICK_SPATIAL_OBJECT: 'map_spatial_layer_click_spatial_object',
  FLOOR_SELECTOR: 'map_spatial_layer_floor_selector',
};

// The tracking in this file are all CRG map card specific. Newer spatial layers
// tracking should be added to spatialTracking.js
export const trackDisclaimerClick = (
  irpVersion,
  showDisclaimerState,
  source,
) => {
  gspx.trackEvent({
    name: SPATIAL_LAYER_EVENT_NAMES.DISCLAIMER_CLICK,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Click to ${
        showDisclaimerState ? 'close' : 'open'
      } ${source} disclaimer`,
      Category: 'Spatial Layer',
      'Launched date': new Date(),
      irpVersion,
      source,
    },
  });
};

/**
 * Track clicks on up/down arrow
 * @param {String} arrowDirection - `up` or `down`
 * @param {String} irpVersion - IRP Version
 * @param {String} source - source of spatial layer
 */
export const trackClickOnFloorArrow = (arrowDirection, irpVersion, source) => {
  gspx.trackEvent({
    name: SPATIAL_LAYER_EVENT_NAMES.CLICK_FLOOR_ARROW,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `${source} toggle floor ${arrowDirection} button`,
      Category: 'Spatial Layer',
      'Launched date': new Date(),
      irpVersion,
      source,
      arrowDirection,
    },
  });
};

export const trackClickLinkOutButton = (irpVersion, source) => {
  gspx.trackEvent({
    name: SPATIAL_LAYER_EVENT_NAMES.CLICK_LINK_OUT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `${source} view PDF`,
      Category: 'Spatial Layer',
      'Launched date': new Date(),
      irpVersion,
      source,
    },
  });
};

export const trackClickOnSpatialObject = (irpVersion, externalId, source) => {
  gspx.trackEvent({
    name: SPATIAL_LAYER_EVENT_NAMES.CLICK_SPATIAL_OBJECT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `Click on ${source} spatial object ${externalId}`,
      Category: 'Spatial Layer',
      'Launched date': new Date(),
      irpVersion,
      source,
      externalId,
    },
  });
};

export const trackFloorSelector = (irpVersion, source) => {
  gspx.trackEvent({
    name: SPATIAL_LAYER_EVENT_NAMES.FLOOR_SELECTOR,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: `${source} select option from floor plan drop-down menu`,
      Category: 'Spatial Layer',
      'Launched date': new Date(),
      irpVersion,
      source,
    },
  });
};
